module.exports = __webpack_public_path__ + "static/media/square.a80e38a4.svg";